import Call from "../../../../hocs/call";
import EnhancedTree from "../../../../components/enhanced-tree";
import {
    getNodeFromMappingSet,
    getUrnFromArtefactTriplet,
    SDMX_JSON_DATAFLOW_URN_NAMESPACE
} from "../../../../utils/sdmxJson";
import {getNodes, UNCATEGORIZED_CATEGORY_CODE} from "../../../../utils/tree";
import {BUTTON_DELETE, BUTTON_EDIT, BUTTON_CREATE} from "../../../../styles/buttons";
import {getLocalizedStr} from "../../../../middlewares/i18n/utils";
import React, {Fragment, useMemo, useState, useEffect, useCallback} from 'react';
import {
    changeCategorySchemesAndDataflowsLanguage,
    readCategorySchemesAndDataflowsTree,
    showWizard, deleteMappingSet
} from "./actions";
import {Button, Col, Modal, Row} from "antd";
import "./style.css"
import {connect} from "react-redux";
import {compose} from "redux";
import {translate} from "react-i18next";
import {GUTTER_SM} from "../../../../styles/constants";
import {Icon} from 'antd';
import {isDataFlowReadOnlyColorIcon, isDataFlowNotInProduction} from "../utils";
import {
    createDataflowsDataflow,
    deleteDataflowsDataflow,
    editDataflowsDataflow
} from "../../../meta-manager/dataflows/actions";
import DataflowDetail from "../../../meta-manager/dataflows/Detail";
import {
    categoriseCategorySchemesAndDataflowsDataflow
} from "../../../meta-manager/category-schemes-and-dataflows/actions";
import {categorisationsSorterFactory} from "../../../meta-manager/category-schemes-and-dataflows/utils";
import {checkStruval, resetSaveStatusMappingSet} from "../mapping-set-wizard/actions";
import EnhancedModal from "../../../../components/enhanced-modal";
import {MODAL_WIDTH_MD, MODAL_WIDTH_SM} from "../../../../styles/constants";
import ArtefactDownloadForm from "../../../../components/artefact-download-form";
import {
    ARTEFACT_TYPE_DATAFLOW,
    ARTEFACT_TYPE_MULTIPLE,
    DOWNLOAD_FORMAT_TYPE_CSV,
    getArtefactDownloadOptions
} from "../../../../constants/download";
import {getStringFromArtefactTriplet} from "../../../../utils/sdmxJson";
import {
    changeDataflowsDataflowClone,
    changeDataflowsDataflowDownload,
    changeDataflowsDataflowExport,
    hideDataflowsDataflowClone,
    hideDataflowsDataflowDownload,
    hideDataflowsDataflowExport,
    hideDataflowsDataflowExportReport,
    submitDataflowsDataflowClone,
    submitDataflowsDataflowDownload,
    submitDataflowsDataflowExport
  } from "./../../../meta-manager/dataflows/actions";

import ArtefactCloneForm from "../../../../components/artefact-clone-form";
import {isCloneDestTripletValid, isExportDestinationValid} from "../../../../utils/artefactValidators";
import ArtefactExportForm from "../../../../components/artefact-export-form";
import ArtefactExportReport from "../../../../components/artefact-export-report";
import ArtefactFullExportForm from "../../../../redux-components/redux-artefact-full-export";




const mapStateToProps = state => ({
    permissions: state.app.user.permissions,
    tree: state.scenes.mappingHandler.mappingSet.tree.tree,
    categorisations: state.scenes.mappingHandler.mappingSet.tree.categorisations,
    annotations: state.scenes.mappingHandler.mappingSet.tree.annotations,
    nodes: state.config.nodes,
    appLanguage: state.app.language,
    dataLanguages: state.config.dataManagement.dataLanguages,
    dataflow: state.scenes.metaManager.dataflows.dataflow,
    saveSuccessful: state.scenes.mappingHandler.mappingSet.wizard.saveSuccessful,
    dataflowIsSuccessCallback: state.scenes.metaManager.dataflows.mappingSetIsSuccessCallback,
    downloadDataflowTriplets: state.scenes.metaManager.dataflows.downloadDataflowTriplets,
    downloadDataflowParams: state.scenes.metaManager.dataflows.downloadDataflowParams,
    downloadDataflowLang: state.scenes.metaManager.dataflows.downloadDataflowLang,
    cloneDestTriplet: state.scenes.metaManager.dataflows.cloneDestTriplet,
    allAgencies: state.scenes.metaManager.dataflows.allAgencies,
    endpoints: state.config.nodes,
    endpointId: state.app.endpointId,
    dataflowExportSourceTriplet: state.scenes.metaManager.dataflows.dataflowExportSourceTriplet,
    dataflowExportDestination: state.scenes.metaManager.dataflows.dataflowExportDestination,
    dataflowExportReport: state.scenes.metaManager.dataflows.dataflowExportReport,

});

const mapDispatchToProps = dispatch => ({
    fetchTree: (t, lang, dataLanguages, categorySchemePermissions, showOnlyCategoriesWithDataflows) => dispatch(readCategorySchemesAndDataflowsTree(t, lang, dataLanguages, categorySchemePermissions, showOnlyCategoriesWithDataflows)),
    onLanguageChange: () => dispatch(changeCategorySchemesAndDataflowsLanguage()),
    onMappingWizardShow: (dataflowTriplet) => dispatch(showWizard(dataflowTriplet)),
    onMappingSetDelete: (mappingSetId, lang, categorySchemePermissions) => dispatch(deleteMappingSet(mappingSetId, lang, categorySchemePermissions)),
    onCreateDataflow: () => dispatch(createDataflowsDataflow()),
    onDetailDataflow: dataflowTriplet => dispatch(editDataflowsDataflow(dataflowTriplet)),
    onDataflowDelete: dataflowTriplet => dispatch(deleteDataflowsDataflow(dataflowTriplet)),
    onDataflowCategorize: (dataflow, categoryUrn, categorisations, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t) =>
        dispatch(categoriseCategorySchemesAndDataflowsDataflow(dataflow, categoryUrn, categorisations, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t)),
    resetSaveStatus: () => dispatch(resetSaveStatusMappingSet()),
    onCheckStruval: () => dispatch(checkStruval()),
    onDownloadHide: () => dispatch(hideDataflowsDataflowDownload()),
    onDownloadChange: fields => dispatch(changeDataflowsDataflowDownload(fields)),
    onDownloadSubmit: (artefactTriplet, downloadDataflowParams, lang) =>
        dispatch(submitDataflowsDataflowDownload(artefactTriplet, downloadDataflowParams, lang)),
    onCloneHide: () => dispatch(hideDataflowsDataflowClone()),
    onCloneChange: fields => dispatch(changeDataflowsDataflowClone(fields)),
    onCloneSubmit: (cloneDestTriplet, srcDataflow, annotationsConfig) =>
      dispatch(submitDataflowsDataflowClone(cloneDestTriplet, srcDataflow, annotationsConfig)),
    onExportHide: () => dispatch(hideDataflowsDataflowExport()),
    onExportChange: fields => dispatch(changeDataflowsDataflowExport(fields)),
    onExportSubmit: (sourceTriplets, destination) => dispatch(submitDataflowsDataflowExport(sourceTriplets, destination)),
    onExportReportHide: () => dispatch(hideDataflowsDataflowExportReport())
});

const MappingSetTree = ({
                            t,
                            permissions,
                            tree,
                            nodes,
                            appLanguage,
                            dataLanguages,
                            fetchTree,
                            dataflow,
                            onMappingSetDelete,
                            onLanguageChange,
                            onMappingWizardShow,
                            onCreateDataflow,
                            onDataflowDelete,
                            onDetailDataflow,
                            dataflowIsSuccessCallback,
                            categorisations,
                            annotations,
                            onDataflowCategorize,
                            saveSuccessful,
                            resetSaveStatus,
                            onCheckStruval,
                            showButtons = true,
                            showOnlyCategoriesWithDataflows = false,
                            downloadDataflowTriplets,
                            onDownloadHide,
                            onDownloadSubmit,
                            downloadDataflowParams,
                            onDownloadChange,
                            downloadDataflowLang,
                            cloneDestTriplet,
                            onCloneHide,
                            onCloneChange,
                            onCloneSubmit,
                            allAgencies,
                            endpoints,
                            endpointId,
                            dataflowExportSourceTriplet,
                            dataflowExportDestination,
                            onExportHide,
                            onExportChange,
                            onExportSubmit,
                            dataflowExportReport,
                            onExportReportHide,
                        }) => {
    const permittedAgencies = permissions ? (allAgencies && Object.fromEntries(Object.entries(allAgencies).filter(([key]) => (permissions.agencies || []).includes(key)))) : {};

    useEffect(() => {
        if (dataflowIsSuccessCallback || saveSuccessful) {
            fetchTree(t, appLanguage, dataLanguages, categorySchemePermissions)
            resetSaveStatus();
        }
    }, [dataflowIsSuccessCallback, saveSuccessful]);

    const [selected, setSelected] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);

    const isCategory = useMemo(() => selected ? selected.startsWith("category") : false, [selected]);
    const isDataflow = useMemo(() => selected ? selected.startsWith("dataflow") : false, [selected]);
    const isMappingSet = useMemo(() => selected ? selected.includes("mappingset") : false, [selected]);

    const actions = useMemo(() => {
        return [
            {
                ...BUTTON_CREATE,
                title: t('components.itemList.actions.add.title'),
                disabled: (!selected || !isCategory),
                onClick: () => onCreateDataflow()
            },
            {
                ...BUTTON_EDIT,
                title: t('commons.actions.detail.title'),

                onClick: () => onDetailDataflow({
                    id: selectedNode.id,
                    agencyID: selectedNode.agencyID,
                    version: selectedNode.version
                }),
                disabled: (!selected || isCategory || isMappingSet),
            },
            {
                ...BUTTON_DELETE,
                disabled: (!selected || isMappingSet || isCategory || selectedNode.hasMappingsets || selectedNode.isReadOnly || !selectedNode.isNotInProduction),
                onClick: () => Modal.confirm({
                    title: t('scenes.mappingHandler.MappingSet.mappingSetDataflowDeletePrompt', {
                        dataflow: selectedNode.id
                    }),
                    onOk() {
                        onDataflowDelete({
                            id: selectedNode.id,
                            agencyID: selectedNode.agencyID,
                            version: selectedNode.version
                        });
                    },
                    cancelText: t('commons.buttons.cancel.title')
                }),
                title: t('components.itemList.actions.delete.title'),
            }
        ];
    }, [selected, isCategory, isDataflow, isMappingSet, selectedNode]);


    const handleOnSelect = useCallback((selectedKeysFromTree) => {
        if (selectedKeysFromTree.length === 1) {
            const splitArray = selectedKeysFromTree[0].split('+');
            const selection = {
                type: splitArray[0],
                id: splitArray[1],
                agencyID: splitArray[2],
                version: splitArray[3],
                parentId: splitArray[4],
                isReadOnly: JSON.parse(splitArray[5]),
                isNotInProduction: JSON.parse(splitArray[6]),
                hasMappingsets: JSON.parse(splitArray[7]),
                name: splitArray[8],
                urn: splitArray[9]

            };
            setSelected(selection.type)
            setSelectedNode(selection)
        } else {
            setSelected(null);
            setSelectedNode(null)
        }
    }, []);

    const categorySchemePermissions = useMemo(() => permissions ? permissions.categoryScheme : [], [permissions]);
    
		const getFilter = useCallback(searchText =>
			({id, name}) => {
				const search = searchText.toLowerCase();
				return (
					id && id.toLowerCase().indexOf(search) >= 0) ||
						getLocalizedStr(name, appLanguage, dataLanguages)
							.toLowerCase()
							.indexOf(search) >= 0;
			}, [appLanguage, dataLanguages]);
    
		const getIcon = useCallback((node) => node && node.type === "dataflow" ?
			<Icon
				theme="outlined"
				style={{
					color: isDataFlowReadOnlyColorIcon(node, annotations) ? 'red' : (isDataFlowNotInProduction(node) ? 'black' : '#d9d9d9')
				}}
				type='file-text'
			/> : null, [annotations]);
    
		const unselectableKeys = useMemo(() => [
			...getNodes(tree, 'categorySchemes', () => true).map(node =>
				node.id === UNCATEGORIZED_CATEGORY_CODE ? UNCATEGORIZED_CATEGORY_CODE : node.treeKey
			)
		], [tree]);

    const leftActions = useMemo(() => showButtons && (
			<Row gutter={GUTTER_SM} type="flex">
				{actions.map((action, index) => (
					<Col key={index}>
						<Button {...action}/>
					</Col>
				))}
			</Row>
		), [actions, showButtons]);

    const treeActions = useMemo(() => showButtons && [
			{
				disabled: (!isDataflow || selectedNode.isReadOnly || selectedNode.hasMappingsets),
				title: t('scenes.mappingHandler.MappingSet.buttons.create.label'),
				onClick: () => onMappingWizardShow(selectedNode),
				icon: 'plus'
			},
			{
				title: t('scenes.mappingHandler.MappingSet.buttons.viewEdit.label'),
				disabled: (!selected || !isMappingSet || selectedNode.isReadOnly || !selectedNode.isNotInProduction),
				onClick: () => onMappingWizardShow(selectedNode),
				icon: 'edit'
			},
			{
				title: t('scenes.mappingHandler.MappingSet.buttons.delete.label'),
				disabled: (!selected || !isMappingSet || selectedNode.isReadOnly || !selectedNode.isNotInProduction),
				icon: 'delete',
				onClick: () => Modal.confirm({
					title: t('scenes.mappingHandler.MappingSet.mappingSetDeletePrompt', {
						mappingSet: selectedNode.name
					}),
					onOk() {
						onMappingSetDelete(selectedNode.id);
					},
					cancelText: t('commons.buttons.cancel.title')
				})
			},
			{
				title: t('scenes.mappingHandler.MappingSet.buttons.sync.label'),
				icon: 'sync',
				onClick: () => fetchTree(t, appLanguage, dataLanguages, categorySchemePermissions)
			},
		], [showButtons, isDataflow, selectedNode, selected, isMappingSet, t, appLanguage, dataLanguages, categorySchemePermissions]);

		const mappingSetCallback = useCallback((dataflowInfo) => {
			const orderAnnotationType = "ORDER";
			const toSisterDfOrderedCategorisations = categorisations.filter(
				({source, target}) =>
					source.includes(SDMX_JSON_DATAFLOW_URN_NAMESPACE) &&
					target === selectedNode.urn
				)
				.sort(categorisationsSorterFactory(orderAnnotationType, appLanguage));
			onDataflowCategorize(
				{
					...dataflowInfo,
					urn: getUrnFromArtefactTriplet(dataflowInfo, SDMX_JSON_DATAFLOW_URN_NAMESPACE)
				},
				selectedNode.urn,
				categorisations,
				toSisterDfOrderedCategorisations.length,
				[],
				toSisterDfOrderedCategorisations,
				appLanguage,
				orderAnnotationType,
				permissions.agencies,
				t
			);
			fetchTree(t, appLanguage, dataLanguages, categorySchemePermissions)
		}, [t, appLanguage, dataLanguages, categorySchemePermissions, categorisations, selectedNode, permissions]);

		const downloadModalFooter = useMemo(() => (
			<div>
				<Button onClick={onDownloadHide}>
					{t('commons.buttons.close.title')}
				</Button>
				<Button
					onClick={
						() => onDownloadSubmit(downloadDataflowTriplets, downloadDataflowParams, downloadDataflowLang)
					}
					type="primary"
					disabled={
						(downloadDataflowParams && downloadDataflowParams.format === null) ||
						(downloadDataflowParams && downloadDataflowParams.format === DOWNLOAD_FORMAT_TYPE_CSV &&
							(
								downloadDataflowParams.csvSeparator === null ||
								downloadDataflowParams.csvSeparator.length !== 1 ||
								downloadDataflowParams.csvLanguage === null
							))
					}
				>
					{t('commons.buttons.download.title')}
				</Button>
			</div>
		), [onDownloadHide, downloadDataflowTriplets, downloadDataflowParams, downloadDataflowLang]);
		
		const downloadModalTitle = useMemo(() => (
			downloadDataflowTriplets && downloadDataflowTriplets.length > 1
				? t('scenes.metaManager.commons.modals.download.titleMulti')
				: t('scenes.metaManager.commons.modals.download.title', {
						triplet: downloadDataflowTriplets
								? getStringFromArtefactTriplet(downloadDataflowTriplets[0])
								: ""
				})
		), [downloadDataflowTriplets]);

		const artefactDownloadOptions = useMemo(() => getArtefactDownloadOptions(
			t,
			(downloadDataflowTriplets && downloadDataflowTriplets.length > 1)
				? ARTEFACT_TYPE_MULTIPLE
				: ARTEFACT_TYPE_DATAFLOW
		), [downloadDataflowTriplets]);

		const cloneModalFooter = useMemo(() => (
			<div>
				<Button onClick={onCloneHide}>
					{t('commons.buttons.close.title')}
				</Button>
				<Button
					onClick={() => {
						if (!isCloneDestTripletValid(cloneDestTriplet)) {
							Modal.warning({
								title: t('commons.alerts.invalidForm.title'),
								content: t('commons.alerts.invalidForm.content')
							});
						} else {
							onCloneSubmit(cloneDestTriplet, dataflow, endpoints.find(endpoint => endpoint.general.id === endpointId).annotations);
						}
					}}
					type="primary"
				>
					{t('commons.artefact.modals.clone.buttons.submit.title')}
				</Button>
			</div>
		), [cloneDestTriplet, dataflow, endpoints]);

		const exportModalFooter = useMemo(() => (
			<div>
				<Button onClick={onExportHide}>{t('commons.buttons.close.title')}</Button>
				<Button
					type="primary"
					onClick={() => {
						if (isExportDestinationValid(dataflowExportDestination)) {
							onExportSubmit(dataflowExportSourceTriplet, dataflowExportDestination)
						} else {
							Modal.warning({
								title: t('commons.alerts.invalidForm.title'),
								content: t('commons.alerts.invalidForm.content')
							});
						}
					}}
				>
					{t('commons.artefact.modals.export.buttons.submit.title')}
				</Button>
			</div>
		), [dataflowExportSourceTriplet, dataflowExportDestination]);

    return (
        categorySchemePermissions.length === 0
            ? <div>
                {t('scenes.metaManager.categorySchemesDataflows.permissions.empty.message')}
            </div>
            : <Fragment>
                <Call
                    cb={() => fetchTree(t, appLanguage, dataLanguages, categorySchemePermissions, showOnlyCategoriesWithDataflows)}
                    disabled={!(nodes && nodes.length > 0 && tree === null)}
                >
                    <Call cb={onCheckStruval}>
                        <Call
                            cb={onLanguageChange}
                            cbParam={appLanguage}
                            checkCbParamChangeOnly
                            disableFirst
                        >
                            <div className="mapping_set__tree">
                                <EnhancedTree
                                    tree={tree}
                                    getNodeKey={node => node.treeKey}
                                    childrenKey="categories"
                                    idKey="id"
                                    nameKey="name"
                                    catIdKey="id"
                                    catNameKey="name"
                                    defaultExpandAll
                                    getFilter={getFilter}
                                    hiddenIdKeys={[UNCATEGORIZED_CATEGORY_CODE]}
                                    getIcon={getIcon}
                                    icon="file"
                                    getIconColor={() => '#4caf50'}
                                    unselectableKeys={unselectableKeys}
                                    leftActions={leftActions}
                                    onSelect={handleOnSelect}
                                    treeActions={treeActions}
                                />
                            </div>
                        </Call>
                    </Call>
                </Call>
                <DataflowDetail
									forceDataflowTypeNormal={true}
									isReadOnly={selectedNode ? selectedNode.isReadOnly : false}
									mappingSetCallback={mappingSetCallback}
									hideVariableTabs
                />
                <EnhancedModal
                    visible={downloadDataflowTriplets !== null && downloadDataflowTriplets !== undefined}
                    onCancel={onDownloadHide}
                    footer={downloadModalFooter}
                    width={MODAL_WIDTH_SM}
                    title={downloadModalTitle}
                >
                    <ArtefactDownloadForm
                        downloadArtefactForm={downloadDataflowParams}
                        onChange={onDownloadChange}
                        options={artefactDownloadOptions}
                        langs={dataLanguages}
                        hasReferences
                    />
                </EnhancedModal>
                <EnhancedModal
                    visible={cloneDestTriplet !== null}
                    width={MODAL_WIDTH_MD}
                    title={t('commons.artefact.modals.clone.title')}
                    onCancel={onCloneHide}
                    footer={cloneModalFooter}
                >
                    <ArtefactCloneForm
                        agencies={permittedAgencies}
                        srcArtefact={dataflow}
                        destTriplet={cloneDestTriplet}
                        onChange={onCloneChange}
                    />
                </EnhancedModal>
                <EnhancedModal
                    visible={dataflowExportSourceTriplet !== null}
                    title={t('commons.artefact.modals.export.title')}
                    width={MODAL_WIDTH_MD}
                    onCancel={onExportHide}
                    footer={exportModalFooter}
                >
                    <ArtefactExportForm
                        type='dataflow'
                        agencies={allAgencies}
                        sourceTriplet={dataflowExportSourceTriplet}
                        destination={dataflowExportDestination}
                        onChange={onExportChange}
                    />
                </EnhancedModal>
                <EnhancedModal
                    visible={dataflowExportReport !== null}
                    title={t('commons.artefact.modals.exportReport.title')}
                    width={MODAL_WIDTH_MD}
                    onCancel={onExportReportHide}
                    footer={<Button onClick={onExportReportHide}>{t('commons.buttons.close.title')}</Button>}
                >
                    <ArtefactExportReport
                        report={dataflowExportReport}
                    />
                </EnhancedModal>
                <ArtefactFullExportForm/>
                
            </Fragment>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(MappingSetTree);

